import SectionHero from "components/SectionHero/SectionHero";
import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionDownloadApp from "./SectionDowloadApp";
import SectionSliderNewCategories from "./SectionSliderNewCategories";
import SectionManagedAds from "./SectionManagedAds";
import { Helmet } from 'react-helmet';
import PosAdBanner from "components/PosAdBanner/PosAdBanner";


 
function PageHome() {


  return (
    <div>
      <Helmet>
        <link rel="canonical" href="https://feelaxo.com/" /> 
        <title>Feelaxo | Book Online Appointments at Salons and Spas Near You</title>
        <meta name="keywords" content="Schedule appointments, salons, spa, wellness centers, Mumbai, Thane, Navi Mumbai, India, schedule online, appointments, Free Salon Management Software, Salon Software for small business, SAP software, Salon POS in India, Salon CRM, add in every page keywords" />
        <meta name="description" content="Discover the best spa and salon services near you with Feelaxo. Explore top rated spas, massage centers, and wellness retreats across cities in India. Book now" />
        
        {/* Preload critical fonts to avoid layout shifts */}
        <link rel="preload" href="https://fonts.googleapis.com/css2?family=Marcellus&display=swap" as="style" />
        <link rel="preload" href="https://fonts.gstatic.com/s/marcellus/v13/wEO_EBrOk8hQLDvIAF8FUQ.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
        
        {/* Additional font preloading for Poppins, which appears to be causing layout shifts */}
        <link rel="preload" href="/static/media/Poppins-Bold.404e299d5b5c6f2991bb.ttf" as="font" type="font/ttf" crossOrigin="anonymous" />
        <link rel="preload" href="/static/media/Poppins-Regular.8081832fc5cfbf634aa6.ttf" as="font" type="font/ttf" crossOrigin="anonymous" />
      </Helmet>
      
      <div className="nc-PageHome relative overflow-hidden">
        <BgGlassmorphism />
        <SectionHero className="pt-5" /> 
        <div className="lg:ml-20 lg:mr-20 ml-8 mr-8 relative space-y-24">
          <div className="relative container py-16">
            <SectionGridFeaturePlaces />
            {/* Managed ads */}
            {/* <SectionManagedAds/> */}
            <SectionSliderNewCategories /> 


            {/* <SectionDownloadApp /> */}
          </div>
        </div> 
      </div>
      <PosAdBanner />
    </div>
  );
}

export default PageHome;